import type { Dictionnaire } from '../type';

export const composants: Dictionnaire['composants'] = {
  champ: {
    masquer: 'Ocultar la contraseña',
    afficher: 'Mostrar la contraseña',
    effacer: 'Borrar la búsqueda',
  },
  badge: {
    officiel: 'Cuenta oficial de Sirocco',
    verifie: 'Cuenta verificada',
  },
  bulleAppel: {
    revenir: (nom: string) => `Volver a la llamada con ${nom}`,
  },
  etat: {
    annule: 'Cancelado por falta de participantes',
    confirme: 'Confirmado',
    spontanee: 'Espontánea',
    enLigne: 'En línea',
    seuil: (n: number) => `(mín. ${n})`,
  },
  vocal: {
    pause: 'Pausa',
    ecouter: 'Escuchar el mensaje de voz',
    apercu: (duree: string) => `Mensaje de voz, ${duree}`,
  },
  onglets: {
    messages: 'Mensajes',
    evenements: 'Eventos',
    feed: 'Feed',
    lieux: 'Lugares',
    profil: 'Perfil',
    annuaire: 'Directorio',
  },
  barre: {
    navigation: 'Navegación principal',
    aRegarder: (onglet: string, n: number) => `${onglet} · ${n} por ver`,
  },
  photo: {
    pasOuverte: 'No se ha podido abrir esta imagen',
    pasPreparee: 'No se ha podido preparar esta foto',
    recadrer: 'Recortar la foto',
    annuler: 'Cancelar',
    choisir: 'Elegir',
  },
  fichier: {
    pasAjoute: 'No se ha podido añadir este archivo',
  },
  scanner: {
    sansCamera: 'Sirocco no tiene acceso a la cámara. Puedes marcar las asistencias a mano.',
  },
  partage: {
    pasParti: 'No se ha podido compartir.',
    lienCopie: 'Enlace copiado.',
    impossible: 'No se puede compartir desde este navegador.',
    copieImpossible: 'No se puede copiar desde este navegador.',
    titre: 'Compartir',
    chercher: 'Busca un amigo o un grupo',
    unInstant: 'Un momento…',
    sansCible: 'Añade amigos o crea un grupo para compartir sin salir de Sirocco.',
    aucun: 'Ningún nombre coincide.',
    envoi: 'Enviando…',
    ailleurs: 'Compartir en otra app',
    copier: 'Copiar el enlace',
    envoyeA: (nom: string) => `Enviado a ${nom}.`,
  },
  image: {
    pasUneImage: 'Este archivo no es una imagen',
    navigateur: 'Tu navegador no puede preparar esta imagen',
    tropLourde: 'Esta imagen pesa demasiado, prueba con otra',
    pasOuverte: 'No se ha podido abrir esta imagen',
  },
  video: {
    tropLourde: (mo: number) =>
      `Este vídeo pesa demasiado: ${mo} MB, para un máximo de 25. Grábalo en calidad normal en lugar de 4K.`,
    tropLongue: (secondes: number) => `Quince segundos como máximo. Este dura ${secondes}.`,
  },
  voix: {
    appareil: 'Tu dispositivo no puede grabar mensajes de voz',
    micro: 'Sirocco no tiene acceso al micrófono. Permítelo en los ajustes.',
    interrompu: 'La grabación se ha interrumpido',
    tropCourt: 'Demasiado corto. Mantén el dedo pulsado un poco más.',
    tropLong: 'Mensaje de voz demasiado largo para enviarlo',
    illisible: 'Grabación ilegible',
  },
  itineraire: {
    plans: 'Mapas',
  },
  billet: {
    monBillet: 'Mi entrada',
  },
  emojis: {
    smileys: 'Emojis',
    gestes: 'Gestos',
    coeurs: 'Corazones',
    animaux: 'Animales',
    nourriture: 'Comida',
    sports: 'Deportes',
    voyages: 'Viajes',
    objets: 'Objetos',
    symboles: 'Símbolos',
  },
};
